module.exports = __webpack_public_path__ + "img/ic_File_1.b0e9988a.svg";